import { styled } from "@mui/material/styles";

export const ReadMore = styled("span")({
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "14px",
    lineHeight: 1.5,
});
